export const sms_input = {
  letter_count: 'Characters: {count} / {total}',
  sms_count: 'Count of sms: {count}'
};
